import { render, staticRenderFns } from "./WarehouseSidebar.vue?vue&type=template&id=2f43ce64&scoped=true&"
import script from "./WarehouseSidebar.vue?vue&type=script&lang=js&"
export * from "./WarehouseSidebar.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseSidebar.vue?vue&type=style&index=0&id=2f43ce64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f43ce64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f43ce64')) {
      api.createRecord('2f43ce64', component.options)
    } else {
      api.reload('2f43ce64', component.options)
    }
    module.hot.accept("./WarehouseSidebar.vue?vue&type=template&id=2f43ce64&scoped=true&", function () {
      api.rerender('2f43ce64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Warehouses/WarehouseSidebar.vue"
export default component.exports